import { DateTime } from 'luxon-business-days';

export function formatPercentage(value) {
  const parsedValue = parseFloat(value);
  return Number.isNaN(parsedValue)
    ? ''
    : new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 2 }).format(parsedValue);
}

export function currency(initalVal) {
  let parsedValue = parseFloat(initalVal);

  if (Number.isNaN(parsedValue)) {
    parsedValue = 0;
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });

  return formatter.format(parsedValue);
}

export function formatdate(dateStr, format = 'MM/dd/yyyy') {
  const parsedDate = DateTime.fromSQL(dateStr);

  if (parsedDate.isValid) {
    return parsedDate.toFormat(format);
  }
  return '';
}

export function useFilters() {
  return {
    currency,
    formatdate,
    percentage: formatPercentage,
  };
}
